import template from './short-form-switcher.jade';

export default () => {
  return {
    template,
    scope: {},
    controller: [
      'addFormLayoutService',
      function (addFormLayoutService) {
        this.layoutService = addFormLayoutService;
      },
    ],
    controllerAs: 'c',
    replace: true,
  };
};
